import { API_BASE_URL } from './apiConfig';

const API_BASE = API_BASE_URL;

export const letterApi = {
  // Get list of letters with pagination and filtering
  async getLettersList({ page = 0, limit = 10 } = {}) {
    const userEmail = localStorage.getItem('userEmail');
    if (!userEmail) {
      throw new Error('Please log in to access PrepLetters');
    }

    const queryParams = new URLSearchParams({ 
      email: userEmail,
      page: page.toString(),
      limit: limit.toString()
    });

    const response = await fetch(`${API_BASE}api/letters/list?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.detail || 'Failed to fetch letters list');
    }

    return response.json();
  },

  // Get raw HTML for iframe display
  getRawLetterUrl(letterId) {
    const userEmail = localStorage.getItem('userEmail');
    if (!userEmail) {
      return null;
    }

    const queryParams = new URLSearchParams({ 
      email: userEmail
    });
    // Return URL that can be used in iframe
    return `${API_BASE}api/letters/raw/${letterId}?${queryParams}`;
  }
};
